/* =========================================================
   EXPLORE.JS — v3.0

   Changes in v3.0:
   - Artist Genre: multi-select checkboxes with OR logic
     (product matches if ANY selected genre tag is present)
   - Artist/Album: uses product_type field (not tags)
     Ross is deleting Type_Album / Type_Artist tags
   - Album Type: new single-select, filters by Type_Studio /
     Type_Live / Type_Comp tags
   - Album Year: renamed from Release Year (same logic)
   - Select Originals: removed entirely
   - All other existing functionality preserved
========================================================= */

(function () {
  'use strict';

  var PER_PAGE     = 40;
  var RESULT_LIMIT = 1000;
  var SESSION_KEY  = 'artrockstore_explore';

  function g(id) { return document.getElementById(id); }

  var els = {
    /* Tag-based single selects */
    gender:    g('select_gender'),
    era:       g('select_era'),
    albumType: g('select_album_type'),
    sortBy:    g('sort_by'),
    viewBy:    g('view_by'),
    /* Product-type select (uses product_type field, not tags) */
    type:      g('select_type'),
    /* Origin multi-select widget */
    originBox:   g('origin_trigger'),
    originPanel: g('origin_panel'),
    originLabel: g('origin_label'),
    originList:  g('origin_list'),
    originClear: g('origin_clear'),
    /* Genre multi-select widget */
    genreBox:   g('genre_trigger'),
    genrePanel: g('genre_panel'),
    genreLabel: g('genre_label'),
    genreList:  g('genre_list'),
    genreClear: g('genre_clear'),
    /* Keyword widget */
    kwBox:     g('kw_trigger'),
    kwPanel:   g('kw_panel'),
    kwLabel:   g('kw_label'),
    kwInput:   g('kw_input'),
    kwClear:   g('kw_clear'),
    /* Album Year widget */
    yearBox:   g('year_trigger'),
    yearPanel: g('year_panel'),
    yearLabel: g('year_label'),
    yearInput: g('year_input'),
    yearHint:  g('year_hint'),
    yearClear: g('year_clear'),
    /* Page controls */
    searchBtn: g('explore_search'),
    resetBtn:  g('explore_reset'),
    loading:   g('explore_loading'),
    results:   g('explore_results')
  };

  if (!els.searchBtn || !els.results) return;

  /* Init wrapper divs for label overlay on all single selects */
  var singleSelects = [els.gender, els.era, els.type, els.albumType, els.sortBy, els.viewBy];
  for (var si = 0; si < singleSelects.length; si++) initSelectWrap(singleSelects[si]);

  /* =========================================================
     ORIGIN MULTI-SELECT WIDGET
     Same pattern as Genre. Checkbox panel. OR logic: product
     matches if it has ANY of the selected origin tags.
     Label shows: "Origin: UK, USA, France"
  ========================================================= */
  function originOpen() {
    if (!els.originPanel) return;
    els.originPanel.classList.add('is-open');
    els.originBox.classList.add('is-open');
  }
  function originClose() {
    if (!els.originPanel) return;
    els.originPanel.classList.remove('is-open');
    if (els.originBox) els.originBox.classList.remove('is-open');
  }
  function originGetValues() {
    if (!els.originList) return [];
    var cbs = els.originList.querySelectorAll('input[type="checkbox"]:checked');
    var vals = [];
    for (var i = 0; i < cbs.length; i++) {
      if (cbs[i].id === 'origin_toggle_cb') continue;
      vals.push(cbs[i].value);
    }
    return vals;
  }
  function originGetLabels() {
    if (!els.originList) return [];
    var cbs = els.originList.querySelectorAll('input[type="checkbox"]:checked');
    var names = [];
    for (var i = 0; i < cbs.length; i++) {
      if (cbs[i].id === 'origin_toggle_cb') continue;
      var lbl = cbs[i].parentNode;
      var txt = lbl.textContent.trim();
      names.push(txt);
    }
    return names;
  }
  function originUpdateLabel() {
    if (!els.originLabel) return;
    var labels = originGetLabels();
    if (labels.length > 0) {
      els.originLabel.textContent = 'Origin: ' + labels.join(', ');
      els.originLabel.classList.add('has-value');
    } else {
      els.originLabel.textContent = 'Artist Origin (Multi)';
      els.originLabel.classList.remove('has-value');
    }
    var toggleCb = g('origin_toggle_cb');
    if (toggleCb) {
      var originCbs = els.originList.querySelectorAll('input[type="checkbox"]:not(#origin_toggle_cb)');
      var allChecked = true;
      for (var i = 0; i < originCbs.length; i++) {
        if (!originCbs[i].checked) { allChecked = false; break; }
      }
      toggleCb.checked = allChecked;
      toggleCb.parentNode.childNodes[toggleCb.parentNode.childNodes.length - 1].textContent =
        allChecked ? ' Clear' : ' Select All';
    }
  }
  function originSetValues(vals) {
    if (!els.originList || !vals || !vals.length) return;
    var cbs = els.originList.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < cbs.length; i++) {
      cbs[i].checked = (vals.indexOf(cbs[i].value) !== -1);
    }
    originUpdateLabel();
  }
  function originClearAll() {
    if (!els.originList) return;
    var cbs = els.originList.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < cbs.length; i++) cbs[i].checked = false;
    originUpdateLabel();
  }
  function originSelectAll() {
    if (!els.originList) return;
    var cbs = els.originList.querySelectorAll('input[type="checkbox"]:not(#origin_toggle_cb)');
    for (var i = 0; i < cbs.length; i++) cbs[i].checked = true;
    originUpdateLabel();
  }

  if (els.originBox) {
    els.originBox.addEventListener('click', function () {
      kwClose(); yearClose(); genreClose(); originClose();
      els.originPanel.classList.contains('is-open') ? originClose() : originOpen();
    });
  }
  if (els.originList) {
    els.originList.addEventListener('change', function(e) {
      if (e.target && e.target.id === 'origin_toggle_cb') {
        if (e.target.checked) { originSelectAll(); } else { originClearAll(); }
        return;
      }
      originUpdateLabel();
    });
  }
  if (els.originClear) {
    els.originClear.addEventListener('click', function (e) {
      e.stopPropagation();
      originClearAll();
    });
  }

  /* =========================================================
     GENRE MULTI-SELECT WIDGET
     Checkbox panel. OR logic: product matches if it has
     ANY of the selected genre tags.
     Label shows: "Genre: Ambient, Blues, Jazz"
  ========================================================= */
  function genreOpen() {
    if (!els.genrePanel) return;
    els.genrePanel.classList.add('is-open');
    els.genreBox.classList.add('is-open');
  }
  function genreClose() {
    if (!els.genrePanel) return;
    els.genrePanel.classList.remove('is-open');
    if (els.genreBox) els.genreBox.classList.remove('is-open');
  }
  function genreGetValues() {
    if (!els.genreList) return [];
    var cbs = els.genreList.querySelectorAll('input[type="checkbox"]:checked');
    var vals = [];
    for (var i = 0; i < cbs.length; i++) {
      if (cbs[i].id === 'genre_toggle_cb') continue; /* skip toggle */
      vals.push(cbs[i].value);
    }
    return vals;
  }
  function genreGetLabels() {
    if (!els.genreList) return [];
    var cbs = els.genreList.querySelectorAll('input[type="checkbox"]:checked');
    var names = [];
    for (var i = 0; i < cbs.length; i++) {
      if (cbs[i].id === 'genre_toggle_cb') continue; /* skip toggle */
      var lbl = cbs[i].parentNode;
      var txt = lbl.textContent.trim();
      names.push(txt);
    }
    return names;
  }
  function genreUpdateLabel() {
    if (!els.genreLabel) return;
    var labels = genreGetLabels();
    if (labels.length > 0) {
      els.genreLabel.textContent = 'Genre: ' + labels.join(', ');
      els.genreLabel.classList.add('has-value');
    } else {
      els.genreLabel.textContent = 'Artist Genre (Multi)';
      els.genreLabel.classList.remove('has-value');
    }
    /* Sync the Select All / Clear toggle checkbox and label */
    var toggleCb = g('genre_toggle_cb');
    if (toggleCb) {
      var genreCbs = els.genreList.querySelectorAll('input[type="checkbox"]:not(#genre_toggle_cb)');
      var allChecked = true;
      for (var i = 0; i < genreCbs.length; i++) {
        if (!genreCbs[i].checked) { allChecked = false; break; }
      }
      toggleCb.checked = allChecked;
      toggleCb.parentNode.childNodes[toggleCb.parentNode.childNodes.length - 1].textContent =
        allChecked ? ' Clear' : ' Select All';
    }
  }
  function genreSetValues(vals) {
    if (!els.genreList || !vals || !vals.length) return;
    var cbs = els.genreList.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < cbs.length; i++) {
      cbs[i].checked = (vals.indexOf(cbs[i].value) !== -1);
    }
    genreUpdateLabel();
  }
  function genreClearAll() {
    if (!els.genreList) return;
    var cbs = els.genreList.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < cbs.length; i++) cbs[i].checked = false;
    genreUpdateLabel();
  }
  function genreSelectAll() {
    if (!els.genreList) return;
    var cbs = els.genreList.querySelectorAll('input[type="checkbox"]:not(#genre_toggle_cb)');
    for (var i = 0; i < cbs.length; i++) cbs[i].checked = true;
    genreUpdateLabel();
  }

  if (els.genreBox) {
    els.genreBox.addEventListener('click', function () {
      kwClose(); yearClose(); genreClose(); originClose();
      els.genrePanel.classList.contains('is-open') ? genreClose() : genreOpen();
    });
  }
  if (els.genreList) {
    els.genreList.addEventListener('change', function(e) {
      /* Handle the Select All / Clear toggle */
      if (e.target && e.target.id === 'genre_toggle_cb') {
        if (e.target.checked) {
          genreSelectAll();
        } else {
          genreClearAll();
        }
        return;
      }
      genreUpdateLabel();
    });
  }
  if (els.genreClear) {
    els.genreClear.addEventListener('click', function (e) {
      e.stopPropagation();
      genreClearAll();
    });
  }

  /* =========================================================
     KEYWORD WIDGET
  ========================================================= */
  function kwOpen() {
    els.kwPanel.classList.add('is-open');
    els.kwBox.classList.add('is-open');
    if (els.kwInput) els.kwInput.focus();
  }
  function kwClose() {
    els.kwPanel.classList.remove('is-open');
    els.kwBox.classList.remove('is-open');
  }
  function kwUpdateLabel() {
    var val = els.kwInput ? els.kwInput.value.trim() : '';
    if (els.kwLabel) {
      els.kwLabel.textContent = val ? 'Keyword: ' + val : 'Keyword (Multi)';
      els.kwLabel.classList.toggle('has-value', !!val);
    }
    if (els.kwClear) els.kwClear.style.display = val ? 'inline-block' : 'none';
  }

  if (els.kwBox) {
    els.kwBox.addEventListener('click', function () {
      yearClose(); genreClose();
      els.kwPanel.classList.contains('is-open') ? kwClose() : kwOpen();
    });
    els.kwBox.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        els.kwPanel.classList.contains('is-open') ? kwClose() : kwOpen();
      }
    });
  }
  if (els.kwInput) {
    els.kwInput.addEventListener('input', kwUpdateLabel);
    els.kwInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); kwClose(); runSearch(1); }
    });
  }
  if (els.kwClear) {
    els.kwClear.addEventListener('click', function (e) {
      e.stopPropagation();
      if (els.kwInput) els.kwInput.value = '';
      kwUpdateLabel();
      kwClose();
    });
  }

  /* =========================================================
     ALBUM YEAR WIDGET
  ========================================================= */
  function yearOpen() {
    if (!els.yearPanel) return;
    els.yearPanel.classList.add('is-open');
    els.yearBox.classList.add('is-open');
    if (els.yearInput) els.yearInput.focus();
  }
  function yearClose() {
    if (!els.yearPanel) return;
    els.yearPanel.classList.remove('is-open');
    if (els.yearBox) els.yearBox.classList.remove('is-open');
  }
  /* Validate a single year string */
  function yearValidateSingle(val) {
    var n = parseInt(val, 10);
    return !isNaN(n) && n > 1900 && n < 2100;
  }
  /* Parse raw input into array of valid years — OR logic */
  function yearParseValues(raw) {
    if (!raw) return [];
    /* Split by spaces, commas, or semicolons */
    var parts = raw.split(/[\s,;]+/).map(function(p) { return p.trim(); }).filter(Boolean);
    return parts.filter(yearValidateSingle);
  }
  /* Get the invalid parts so we can show a hint */
  function yearGetInvalidParts(raw) {
    if (!raw) return [];
    var parts = raw.split(/[\s,;]+/).map(function(p) { return p.trim(); }).filter(Boolean);
    return parts.filter(function(p) { return !yearValidateSingle(p); });
  }
  function yearUpdateLabel() {
    if (!els.yearInput || !els.yearLabel) return;
    var raw = els.yearInput.value.trim();
    var validYears = yearParseValues(raw);
    var invalidParts = yearGetInvalidParts(raw);
    if (els.yearHint) {
      if (invalidParts.length > 0) {
        els.yearHint.textContent = 'Invalid: ' + invalidParts.join(', ') + ' — use years between 1901 and 2099';
        els.yearHint.style.display = 'block';
      } else {
        els.yearHint.textContent = '';
        els.yearHint.style.display = 'none';
      }
    }
    if (validYears.length > 0) {
      els.yearLabel.textContent = 'Year: ' + validYears.join(', ');
      els.yearLabel.classList.add('has-value');
    } else {
      els.yearLabel.textContent = 'Album Year (Multi)';
      els.yearLabel.classList.remove('has-value');
    }
    if (els.yearClear) els.yearClear.style.display = (raw) ? 'inline-block' : 'none';
  }
  function yearGetValue() {
    if (!els.yearInput) return [];
    return yearParseValues(els.yearInput.value.trim());
  }

  if (els.yearBox) {
    els.yearBox.addEventListener('click', function () {
      kwClose(); genreClose();
      els.yearPanel.classList.contains('is-open') ? yearClose() : yearOpen();
    });
    els.yearBox.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        els.yearPanel.classList.contains('is-open') ? yearClose() : yearOpen();
      }
    });
  }
  if (els.yearInput) {
    els.yearInput.addEventListener('input', yearUpdateLabel);
    els.yearInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var raw = els.yearInput.value.trim();
        var invalidParts = yearGetInvalidParts(raw);
        if (invalidParts.length > 0) {
          if (els.yearHint) {
            els.yearHint.textContent = 'Invalid: ' + invalidParts.join(', ') + ' — use years between 1901 and 2099';
            els.yearHint.style.display = 'block';
          }
          return;
        }
        yearClose(); runSearch(1);
      }
    });
  }
  if (els.yearClear) {
    els.yearClear.addEventListener('click', function (e) {
      e.stopPropagation();
      if (els.yearInput) els.yearInput.value = '';
      yearUpdateLabel();
      if (els.yearInput) els.yearInput.focus();
    });
  }

  /* Close all panels when clicking outside */
  function handleOutsideClick(e) {
    var t = e.target;
    if (!t) return;
    if (t.tagName === 'SELECT' || t.tagName === 'OPTION') return;
    if (typeof t.closest === 'function' && t.closest('select')) return;
    /* Keyword */
    if (els.kwBox && !els.kwBox.contains(t) &&
        (!els.kwPanel || !els.kwPanel.contains(t))) {
      kwClose();
    }
    /* Year */
    if (els.yearBox && !els.yearBox.contains(t) &&
        (!els.yearPanel || !els.yearPanel.contains(t))) {
      yearClose();
    }
    /* Genre multi-select */
    if (els.genreBox && !els.genreBox.contains(t) &&
        (!els.genrePanel || !els.genrePanel.contains(t))) {
      genreClose();
    }
    /* Origin multi-select */
    if (els.originBox && !els.originBox.contains(t) &&
        (!els.originPanel || !els.originPanel.contains(t))) {
      originClose();
    }
  }
  document.addEventListener('click', handleOutsideClick);

  /* =========================================================
     HELPERS
  ========================================================= */
  function esc(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/\"/g,'&quot;');
  }
  function norm(str) { return String(str || '').toLowerCase().trim(); }
  function showLoading(on) { if (els.loading) els.loading.style.display = on ? 'block' : 'none'; }

  /* =========================================================
     SELECT LABEL DISPLAY — "Origin: UK", "Type: Albums" etc.
  ========================================================= */
  var SELECT_LABELS = {
    'select_gender':     'Gender',
    'select_era':        'Era',
    'select_type':       'Type',
    'select_album_type': 'Album Type',
    'sort_by':           'Sort by',
    'view_by':           'View by'
  };
  var VALUE_DISPLAY = {
    'Albums': 'Albums', 'Artists': 'Artists',
    'Studio': 'Studio', 'Live': 'Live', 'Compilation': 'Compilation'
  };

  function initSelectWrap(el) {
    if (!el || !el.parentNode) return;
    if (el.parentNode.classList && el.parentNode.classList.contains('explore-select-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'explore-select-wrap';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    var lbl = document.createElement('div');
    lbl.className = 'explore-select-label';
    wrap.appendChild(lbl);
    el._wrap  = wrap;
    el._label = lbl;
  }

  function updateSelectDisplay(el) {
    if (!el) return;
    var hasVal = (el.value !== '');
    el.classList.toggle('has-value', hasVal);
    if (!el._label) return;
    if (hasVal) {
      var prefix  = SELECT_LABELS[el.id] || '';
      var optText = (el.options && el.selectedIndex >= 0)
                    ? el.options[el.selectedIndex].text : el.value;
      var disp = VALUE_DISPLAY.hasOwnProperty(optText) ? VALUE_DISPLAY[optText] : optText;
      el._label.textContent = prefix ? (prefix + ': ' + disp) : disp;
      el._label.style.display = 'flex';
    } else {
      el._label.textContent = '';
      el._label.style.display = 'none';
    }
  }

  function updateAllSelects() {
    for (var i = 0; i < singleSelects.length; i++) updateSelectDisplay(singleSelects[i]);
  }

  /* Wire change events for label display */
  for (var ci = 0; ci < singleSelects.length; ci++) {
    (function(el) {
      if (el) el.addEventListener('change', function() { updateSelectDisplay(el); });
    }(singleSelects[ci]));
  }

  /* =========================================================
     STATE — read, apply, clear
  ========================================================= */
  function getState() {
    return {
      origins:   originGetValues(), /* array of tag values — OR logic */
      gender:    els.gender    ? els.gender.value    : '',
      era:       els.era       ? els.era.value       : '',
      genres:    genreGetValues(), /* array of tag values */
      type:      els.type      ? els.type.value      : '',
      albumType: els.albumType ? els.albumType.value  : '',
      releaseYear: yearGetValue(), /* now an array of years */
      keyword:   els.kwInput   ? els.kwInput.value.trim() : '',
      sort:      els.sortBy    ? els.sortBy.value    : '',
      view:      els.viewBy    ? (els.viewBy.value || 'grid') : 'grid'
    };
  }

  function applyState(st) {
    if (st.origins && st.origins.length) originSetValues(st.origins);
    if (els.gender    && st.gender)    els.gender.value    = st.gender;
    if (els.era       && st.era)       els.era.value       = st.era;
    if (els.type      && st.type)      els.type.value      = st.type;
    if (els.albumType && st.albumType) els.albumType.value  = st.albumType;
    if (els.sortBy)                    els.sortBy.value    = st.sort || '';
    if (els.viewBy)                    els.viewBy.value    = st.view || '';
    if (st.genres && st.genres.length) genreSetValues(st.genres);
    if (els.kwInput && st.keyword) {
      els.kwInput.value = st.keyword;
      kwUpdateLabel();
    }
    if (els.yearInput && st.releaseYear && st.releaseYear.length) {
      els.yearInput.value = Array.isArray(st.releaseYear) ? st.releaseYear.join(', ') : st.releaseYear;
      yearUpdateLabel();
    }
    updateAllSelects();
  }

  function clearState() {
    originClearAll();
    if (els.gender)    els.gender.value    = '';
    if (els.era)       els.era.value       = '';
    if (els.type)      els.type.value      = '';
    if (els.albumType) els.albumType.value  = '';
    if (els.sortBy)    els.sortBy.value    = '';
    if (els.viewBy)    els.viewBy.value    = '';
    if (els.kwInput)   els.kwInput.value   = '';
    if (els.yearInput) els.yearInput.value = '';
    genreClearAll();
    kwUpdateLabel();
    yearUpdateLabel();
    kwClose(); yearClose(); genreClose(); originClose(); originClose();
    updateAllSelects();
    if (els.results) els.results.innerHTML = '';
    try { sessionStorage.removeItem(SESSION_KEY); } catch(e) {}
  }

  /* =========================================================
     FILTERING
  ========================================================= */
  function productHasTag(product, tag) {
    if (!product.tags || !tag) return false;
    var tn = norm(tag);
    for (var i = 0; i < product.tags.length; i++) {
      if (norm(product.tags[i]) === tn) return true;
    }
    return false;
  }
  function productMatchesTags(product, tags) {
    /* AND: all tags must match */
    for (var i = 0; i < tags.length; i++) {
      if (!productHasTag(product, tags[i])) return false;
    }
    return true;
  }

  /* Origin: OR logic — product matches if it has ANY of the selected origins */
  function productMatchesOrigins(product, origins) {
    if (!origins || origins.length === 0) return true;
    for (var i = 0; i < origins.length; i++) {
      if (productHasTag(product, origins[i])) return true;
    }
    return false;
  }

  /* Genre: OR logic — product matches if it has ANY of the selected genres */
  function productMatchesGenres(product, genres) {
    if (!genres || genres.length === 0) return true;
    for (var i = 0; i < genres.length; i++) {
      if (productHasTag(product, genres[i])) return true;
    }
    return false; /* has NONE of the selected genres */
  }

  /* Product type filter: uses product_type field (not tags) */
  function productMatchesType(product, typeVal) {
    if (!typeVal) return true;
    return norm(product.product_type) === norm(typeVal);
  }

  /* AND keyword logic: ALL words must appear in title */
  function productMatchesKeyword(product, keyword) {
    if (!keyword) return true;
    var parts = keyword.split(/\s+/).map(norm).filter(Boolean);
    var title = norm(product.title);
    for (var i = 0; i < parts.length; i++) {
      if (title.indexOf(parts[i]) === -1) return false;
    }
    return true;
  }

  /* Album Year: exact match on album_info.year metafield */
  /* Year: OR logic — product matches if its year matches ANY selected year */
  function productMatchesYear(product, years) {
    if (!years || years.length === 0) return true;
    var py = String(product.year || '').trim();
    if (!py) return false;
    for (var i = 0; i < years.length; i++) {
      if (py === String(years[i]).trim()) return true;
    }
    return false;
  }

  /* =========================================================
     SORTING
  ========================================================= */
  function sortProducts(products, mode) {
    var s = products.slice();
    switch (mode) {
      case 'year_desc':
        s.sort(function(a,b){ return (parseInt(b.year,10)||0) - (parseInt(a.year,10)||0); });
        break;
      case 'year_asc':
        s.sort(function(a,b){ return (parseInt(a.year,10)||0) - (parseInt(b.year,10)||0); });
        break;
      case 'score_desc':
        s.sort(function(a,b){ return (parseFloat(b.score)||0) - (parseFloat(a.score)||0); });
        break;
      case 'score_asc':
        s.sort(function(a,b){ return (parseFloat(a.score)||0) - (parseFloat(b.score)||0); });
        break;
      default:
        s.sort(function(a,b) {
          var an = norm(a.title), bn = norm(b.title);
          return an < bn ? -1 : an > bn ? 1 : 0;
        });
    }
    return s;
  }

  /* =========================================================
     DATA FETCH
  ========================================================= */
  function buildUrl(page) {
    return '/collections/all?view=explore-json&page=' + page;
  }
  function fetchAll() {
    return fetch(buildUrl(1))
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var products = data.products || [];
        var total = parseInt(data.pages, 10) || 1;
        if (total <= 1) return products;
        var promises = [];
        for (var p = 2; p <= total; p++) {
          (function(page) {
            promises.push(
              fetch(buildUrl(page))
                .then(function(r) { return r.json(); })
                .then(function(d) { return d.products || []; })
                .catch(function() { return []; })
            );
          }(p));
        }
        return Promise.all(promises).then(function(pages) {
          for (var i = 0; i < pages.length; i++) {
            products = products.concat(pages[i]);
          }
          return products;
        });
      });
  }

  /* =========================================================
     RENDER: GRID
  ========================================================= */
  function renderGrid(products, total, limited) {
    var countStr;
    if (limited) {
      countStr = ' <span class="explore-count">(1,000 limit reached)</span>';
    } else if (typeof total !== 'undefined') {
      countStr = ' <span class="explore-count">(' + total.toLocaleString() + ' result' + (total !== 1 ? 's' : '') + ')</span>';
    } else {
      countStr = '';
    }
    var html = '<br><h2 class="explore-results-heading">Search Results' + countStr + '</h2><hr>';
    var hasItems = false;
    var inner = '';

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p.featured_image) continue;
      hasItems = true;
      var priceRaw = parseInt(String(p.price_raw || '0'), 10);
      var priceHtml = (priceRaw > 0 && p.price)
        ? '<p class="grid-link__meta">' + esc(p.price) + '</p>'
        : '';

      inner += '<div class="grid__item wide--one-fifth large--one-quarter medium-down--one-half">';
      inner += '<a href="' + esc(p.url) + '" class="grid-link">';
      inner += '<span class="grid-link__image grid-link__image--product">';
      inner += '<span class="grid-link__image-centered">';
      inner += '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">';
      inner += '</span></span>';
      inner += '<p class="grid-link__title">' + esc(p.title) + '</p>';
      inner += priceHtml;
      inner += '</a></div>';
    }

    if (!hasItems) return html + '<p class="explore-no-results">No results found.</p>';
    return html + '<div class="grid-uniform grid-link__container">' + inner + '</div>';
  }

  /* =========================================================
     RENDER: LIST
  ========================================================= */
  function renderList(products, total, limited) {
    var countStr;
    if (limited) {
      countStr = ' <span class="explore-count">(1,000 limit reached)</span>';
    } else if (typeof total !== 'undefined') {
      countStr = ' <span class="explore-count">(' + total.toLocaleString() + ' result' + (total !== 1 ? 's' : '') + ')</span>';
    } else {
      countStr = '';
    }
    var html = '<br><h2 class="explore-results-heading">Search Results' + countStr + '</h2><hr>';
    if (!products.length) return html + '<p class="explore-no-results">No results found.</p>';

    html += '<div class="explore-list-wrap"><table class="explore-list-table">';
    html += '<thead><tr><th>Year</th><th>Score</th><th>Title</th></tr></thead><tbody>';
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      html += '<tr>';
      html += '<td>' + esc(p.year  || '') + '</td>';
      html += '<td>' + esc(p.score || '') + '</td>';
      html += '<td class="explore-list-title-cell"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></td>';
      html += '</tr>';
    }
    html += '</tbody></table></div>';
    return html;
  }

  /* =========================================================
     RENDER: PAGINATION
  ========================================================= */
  function renderPagination(currentPage, totalPages) {
    if (totalPages <= 1) return '';

    var html = '<br><br><div class="text-center">';
    html += '<ul class="pagination-custom">';

    if (currentPage > 1) {
      html += '<li><a href="#" class="explore-pg" data-page="' + (currentPage - 1) + '">&larr;</a></li>';
    } else {
      html += '<li class="disabled"><span>&larr;</span></li>';
    }

    var start = Math.max(1, currentPage - 1);
    var end   = Math.min(totalPages, currentPage + 1);
    if (end - start < 2) end = Math.min(totalPages, start + 2);

    if (start > 1) {
      html += '<li><a href="#" class="explore-pg" data-page="1">1</a></li>';
      if (start > 2) html += '<li><span>&hellip;</span></li>';
    }
    for (var i = start; i <= end; i++) {
      if (i === currentPage) html += '<li class="active"><span>' + i + '</span></li>';
      else html += '<li><a href="#" class="explore-pg" data-page="' + i + '">' + i + '</a></li>';
    }
    if (end < totalPages) {
      if (end < totalPages - 1) html += '<li><span>&hellip;</span></li>';
      html += '<li><a href="#" class="explore-pg" data-page="' + totalPages + '">' + totalPages + '</a></li>';
    }

    if (currentPage < totalPages) {
      html += '<li><a href="#" class="explore-pg" data-page="' + (currentPage + 1) + '">&rarr;</a></li>';
    } else {
      html += '<li class="disabled"><span>&rarr;</span></li>';
    }

    html += '</ul>';
    html += '<br>';
    html += '<ul class="pagination-custom">';
    html += '<li>Jump to page:</li>';
    html += '<li class="jumpto">';
    html += '<input type="number" class="explore-jumpto-input" id="explore_jump_input" min="1" max="' + totalPages + '" value="' + currentPage + '">';
    html += '<input type="submit" id="explore_jump_btn" value="&gt;" class="btn">';
    html += '</li>';
    html += '</ul>';
    html += '</div>';

    return html;
  }

  /* =========================================================
     WIRE PAGINATION EVENTS
  ========================================================= */
  function wirePagination(currentPage, totalPages, state) {
    var links = els.results.querySelectorAll('.explore-pg');
    for (var i = 0; i < links.length; i++) {
      (function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var p = parseInt(link.getAttribute('data-page'), 10);
          if (p && p !== currentPage) runSearch(p, state);
        });
      }(links[i]));
    }
    var ji = g('explore_jump_input'), jb = g('explore_jump_btn');
    if (jb && ji) {
      var doJump = function() {
        var p = parseInt(ji.value, 10);
        if (p >= 1 && p <= totalPages && p !== currentPage) runSearch(p, state);
      };
      jb.addEventListener('click', function(e) { e.preventDefault(); doJump(); });
      ji.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); doJump(); } });
    }
  }

  /* =========================================================
     MAIN SEARCH
  ========================================================= */
  function runSearch(page, state) {
    page  = page  || 1;
    state = state || getState();
    showLoading(true);
    els.results.innerHTML = '';

    /* Build tag array for AND-logic tag filters
       (gender, era, albumType — NOT origin, NOT genre, NOT type) */
    var tags = [];
    if (state.gender)    tags.push(state.gender);
    if (state.era)       tags.push(state.era);
    if (state.albumType) tags.push(state.albumType);

    fetchAll()
      .then(function(products) {
        /* AND tag filters (gender, era, albumType) */
        products = products.filter(function(p) { return productMatchesTags(p, tags); });
        /* Origin: OR logic — product must match ANY selected origin */
        products = products.filter(function(p) { return productMatchesOrigins(p, state.origins); });
        /* Genre: OR logic — product must match ANY selected genre */
        products = products.filter(function(p) { return productMatchesGenres(p, state.genres); });
        /* Product type filter (Album/Artist via product_type field) */
        products = products.filter(function(p) { return productMatchesType(p, state.type); });
        /* Keyword filter */
        products = products.filter(function(p) { return productMatchesKeyword(p, state.keyword); });
        /* Album Year filter */
        products = products.filter(function(p) { return productMatchesYear(p, state.releaseYear); });
        /* Sort */
        products = sortProducts(products, state.sort);

        var total   = products.length;
        var limited = false;
        if (total > RESULT_LIMIT) {
          products = products.slice(0, RESULT_LIMIT);
          total    = RESULT_LIMIT;
          limited  = true;
        }
        var totalPages = Math.max(1, Math.ceil(total / PER_PAGE));
        if (page > totalPages) page = totalPages;
        var paged = products.slice((page - 1) * PER_PAGE, page * PER_PAGE);

        var html = (state.view === 'list')
          ? renderList(paged, total, limited)
          : renderGrid(paged, total, limited);
        html += renderPagination(page, totalPages);
        els.results.innerHTML = html;
        wirePagination(page, totalPages, state);

        if (page > 1) els.results.scrollIntoView({ behavior: 'smooth', block: 'start' });

        try { sessionStorage.setItem(SESSION_KEY, JSON.stringify({ state: state, page: page })); } catch(e) {}
      })
      .catch(function(err) {
        els.results.innerHTML = '<p class="explore-no-results">Error loading results. Please try again.</p>';
        console.error('Explore error:', err);
      })
      .then(function() { showLoading(false); });
  }

  /* =========================================================
     EVENTS
  ========================================================= */
  els.searchBtn.addEventListener('click', function(e) {
    e.preventDefault();
    if (els.yearInput) {
      var raw = els.yearInput.value.trim();
      var invalidParts = yearGetInvalidParts(raw);
      if (invalidParts.length > 0) {
        if (els.yearHint) {
          els.yearHint.textContent = 'Invalid: ' + invalidParts.join(', ') + ' — use years between 1901 and 2099';
          els.yearHint.style.display = 'block';
        }
        els.yearInput.focus();
        return;
      }
    }
    kwClose(); yearClose(); genreClose(); originClose();
    runSearch(1);
  });
  if (els.resetBtn) {
    els.resetBtn.addEventListener('click', function(e) {
      e.preventDefault();
      clearState();
    });
  }

  /* =========================================================
     BACK-BUTTON RESTORE
  ========================================================= */
  (function() {
    try {
      var raw = sessionStorage.getItem(SESSION_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (saved && saved.state) {
        applyState(saved.state);
        runSearch(saved.page || 1, saved.state);
      }
    } catch(e) {}
  }());

}());